import { useState, useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'
import {
  subscribeToConversations,
  getUnreadCount,
} from '@/services/api/conversations'
import type { Conversation } from '@/types/conversation'

export function useConversations() {
  const { user } = useAuthStore()
  const [conversations, setConversations] = useState<Conversation[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!user) {
      setConversations([])
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setError(null)

    const unsubscribe = subscribeToConversations(user.uid, (data) => {
      setConversations(data)
      setIsLoading(false)
    })

    return () => unsubscribe()
  }, [user])

  return {
    conversations,
    isLoading,
    error,
  }
}

export function useUnreadCount() {
  const { user } = useAuthStore()
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!user) {
      setCount(0)
      return
    }

    // Initial fetch
    getUnreadCount(user.uid).then(setCount)

    // Subscribe to conversations for real-time unread count
    const unsubscribe = subscribeToConversations(user.uid, (conversations) => {
      const unreadConvos = conversations.filter((c) => c.unreadBy === user.uid)
      setCount(unreadConvos.length)
    })

    return () => unsubscribe()
  }, [user])

  return count
}
